import Section from "../UI/Section";
import TaskForm from "./TaskForm";
import useHttp from "../../hooks/use-http";

const NewTask = (props) => {
  const { isLoading, error, sendRequest: sendTaskRequest } = useHttp();

  const createTask = (taskText, taskData) => {
    console.log("taskText");
    console.log(taskText);
    console.log("taskData");
    console.log(taskData);

    const head = Date.now().toString(36);
    const tail = Math.random().toString(36).substr(2);    
    const generatedId = head + tail;
    console.log(generatedId);
    const createdTask = {
      id: generatedId,
      taak: taskText.taak,
      status: taskText.status,
      begindatum: taskText.begindatum,
      einddatum: taskText.einddatum,
    };
    console.log(createdTask);

    props.onAddTask(createdTask);
  };

  // De parameters van sendRequest (sendTaskRequest is de alias voor sendRequest) zijn: requestConfig, fncResponseData
  const enterTaskHandler = async (taskText) => {
    sendTaskRequest(
      {
        url: "https://www.marchouben.nl/php/taken-post.php",
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        body: {
          taak: taskText.taak,
          status: taskText.status,
          begindatum: taskText.begindatum,
          einddatum: taskText.einddatum,
        },
      },
      createTask.bind(null, taskText)
    );
  };

  return (
    <Section>
      <TaskForm onEnterTask={enterTaskHandler} loading={isLoading} />
      {error && <p>{error}</p>}
    </Section>
  );
};

export default NewTask;